"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _oxygenTag = _interopRequireDefault(require("@8x8/oxygen-tag"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _styled = require("../styled");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TagWrapper = (0, _styledComponents["default"])(_oxygenTag["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-width: 3rem;\n"])));
var MultiValue = function MultiValue(props) {
  var _props$selectProps = props.selectProps,
    isDisabled = _props$selectProps.isDisabled,
    testId = _props$selectProps.testId,
    removeProps = props.removeProps,
    isFocused = props.isFocused,
    data = props.data,
    children = props.children;
  var isFixed = !!(data !== null && data !== void 0 && data.isFixed);
  var canRemoveValue = !isFixed && !isDisabled;
  var tagProps = {
    variant: 'dark',
    isFocused: isFocused,
    avatar: data.avatar
  };
  if (canRemoveValue) {
    tagProps.action = removeProps.onClick;
  }
  return /*#__PURE__*/_react["default"].createElement(TagWrapper, _extends({
    testId: "".concat(testId, "_TAG")
  }, tagProps), /*#__PURE__*/_react["default"].createElement(_styled.Ellipsis, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_TAG_VALUE")), children));
};
MultiValue.propTypes = {
  children: _propTypes["default"].node,
  selectProps: _propTypes["default"].shape({
    isDisabled: _propTypes["default"].bool,
    testId: _propTypes["default"].string
  }).isRequired,
  removeProps: _propTypes["default"].shape({
    onClick: _propTypes["default"].func
  }),
  isFocused: _propTypes["default"].bool,
  data: _propTypes["default"].shape({
    avatar: _propTypes["default"].shape(),
    label: _propTypes["default"].string,
    isFixed: _propTypes["default"].bool
  }).isRequired
};
MultiValue.defaultProps = {
  isFocused: false,
  children: null,
  removeProps: {}
};
var _default = MultiValue;
exports["default"] = _default;